import React from 'react';
import { MapPin, Clock } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function Solution() {
  const {
    t
  } = useLanguage();
  return <Section className="bg-barber-black" data-id="element-375">
      <div className="max-w-4xl mx-auto text-center" data-id="element-376">
        <div className="w-24 h-1 bg-barber-gold mx-auto mb-10" data-id="element-377"></div>
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-barber-text uppercase leading-tight mb-8" data-id="element-378">
          {t('solution.heading1')} <br className="hidden md:block" data-id="element-379" />
          <span className="text-barber-gold" data-id="element-380">{t('solution.heading2')}</span>
        </h2>
        <p className="text-2xl md:text-3xl text-barber-muted font-light mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-381">
          {t('solution.subtitle')}
        </p>
        <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto" data-id="element-382">
          <a href="https://www.google.com/maps/search/?api=1&query=926A+East+Tremont+Ave+Bronx+NY+10460" target="_blank" rel="noopener noreferrer" className="bg-barber-gray p-8 rounded-sm border border-barber-lightGray flex flex-col items-center justify-center text-center group hover:border-barber-gold/50 transition-colors cursor-pointer" data-id="element-383">
            <MapPin className="text-barber-gold w-12 h-12 mb-4 group-hover:scale-110 transition-transform" data-id="element-384" />
            <h3 className="font-heading text-xl font-bold uppercase tracking-wider mb-2" data-id="element-385">
              {t('solution.card1Title')}
            </h3>
            <p className="text-barber-muted" data-id="element-386">926A East Tremont Ave</p>
            <p className="text-barber-gold text-sm mt-2 font-bold uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-387">
              {t('solution.card1Sub')}
            </p>
          </a>
          <div className="bg-barber-gray p-8 rounded-sm border border-barber-gold/30 flex flex-col items-center justify-center text-center relative overflow-hidden group" data-id="element-388">
            <div className="absolute inset-0 bg-barber-gold/5 group-hover:bg-barber-gold/10 transition-colors" data-id="element-389"></div>
            <Clock className="text-barber-gold w-12 h-12 mb-4 group-hover:scale-110 transition-transform relative z-10" data-id="element-390" />
            <h3 className="font-heading text-xl font-bold uppercase tracking-wider mb-4 relative z-10" data-id="element-391">
              {t('solution.card2Title')}
            </h3>
            <div className="relative z-10 space-y-2 text-left w-full" data-id="element-392">
              <div className="flex justify-between items-center border-b border-barber-lightGray pb-2" data-id="element-393">
                <span className="text-barber-muted text-sm" data-id="element-394">
                  {t('solution.monThu')}
                </span>
                <span className="text-barber-gold font-heading font-bold" data-id="element-395">
                  8:30 AM – 8:00 PM
                </span>
              </div>
              <div className="flex justify-between items-center border-b border-barber-lightGray pb-2" data-id="element-396">
                <span className="text-barber-muted text-sm" data-id="element-397">
                  {t('solution.fri')}
                </span>
                <span className="text-barber-gold font-heading font-bold" data-id="element-398">
                  8:30 AM – 9:00 PM
                </span>
              </div>
              <div className="flex justify-between items-center border-b border-barber-lightGray pb-2" data-id="element-399">
                <span className="text-barber-muted text-sm" data-id="element-400">
                  {t('solution.sat')}
                </span>
                <span className="text-barber-gold font-heading font-bold" data-id="element-401">
                  8:30 AM – 9:00 PM
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-402">
                <span className="text-barber-muted text-sm" data-id="element-403">
                  {t('solution.sun')}
                </span>
                <span className="text-barber-gold font-heading font-bold" data-id="element-404">
                  10:00 AM – 5:00 PM
                </span>
              </div>
            </div>
          </div>
        </div>
        <p className="mt-12 text-xl text-barber-text font-medium italic" data-id="element-405">
          {t('solution.closing')}
        </p>
      </div>
    </Section>;
}